import { useT } from "../i18n/hooks.ts";
import type { TraceDirection } from "./useNetworkTrace.ts";

export function NetworkTraceBar({
  direction,
  startNode,
  nodeCount,
  linkCount,
  onClose,
}: {
  direction: TraceDirection;
  startNode: string;
  nodeCount: number;
  linkCount: number;
  onClose: () => void;
}) {
  const t = useT();
  return (
    <div className="results-animation-bar">
      <span className="results-animation-label">
        {t(
          direction === "downstream"
            ? "networkTrace.resultDownstream"
            : "networkTrace.resultUpstream",
          {
            name: startNode,
            nodes: nodeCount,
            links: linkCount,
          }
        )}
      </span>
      <button className="button" onClick={onClose}>
        {t("common.close")}
      </button>
    </div>
  );
}
